<template>
    <!-- https://letrari.us21.list-manage.com/subscribe/post?u=63e4fde2e4b46c62fddbac02c&amp;id=870a1cf0d2&amp;f_id=00e259e1f0 -->
    <form action="/newsletter" autocomplete="off" method="POST" id="newsletterForm" @submit.prevent="checkForm">
        <input type="hidden" name="_token" :value="csrf">
        <input type="hidden" name="_form_token" :value="formToken">
        <input type="hidden" name="lang" :value="lang">
        <div aria-hidden="true" style="position:absolute;left:-10000px;width:1px;height:1px;overflow:hidden;">
            <input type="text" name="website" tabindex="-1" autocomplete="off" value="">
        </div>
        <span class="relative flex flex-col w-full mt-20 text-white">
            <button @click="checkForm" type="button" class="absolute bottom-2.5 rounded-full bg-white/20 hover:bg-white right-3 w-[40px] h-[40px] flex items-center justify-center transition-all">
                <svg class="text-primary-400" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="21.414px" height="15.683px" viewBox="0 0 21.414 15.683" enable-background="new 0 0 21.414 15.683" xml:space="preserve">
                    <g>
                        <line fill="none" stroke="currentColor" stroke-miterlimit="10" x1="0" y1="7.841" x2="20.715" y2="7.841"/>
                        <polyline fill="none" stroke="currentColor" stroke-miterlimit="10" points="13.219,0.354 20.707,7.841 13.219,15.329 	"/>
                    </g>
                </svg>
            </button>
            <input @focus="validation.email.state = null" class="pb-2 px-3 border-b border-white/50 bg-transparent outline-none h-[41px] text-white text-1.5xl peer" placeholder=" " id="email" name="EMAIL" type="email" v-model="form.email" />
            <label class="text-white text-xs absolute left-3 -top-4 !tracking-[0.01em] font-light opacity-50 pointer-events-none peer-focus:!text-xs peer-focus:-top-4 peer-placeholder-shown:text-[20px] peer-placeholder-shown:sm:text-[22px] peer-placeholder-shown:md:text-[24px] peer-placeholder-shown:lg:text-[26px] peer-placeholder-shown:xl:text-[28px] peer-placeholder-shown:2xl:text-[30px] peer-placeholder-shown:top-0 transition-all">
                {{$root.translateString('newsletter-label')}}
            </label>
        </span>
        <span v-if="validation.email.state != null" class="text-red-400 px-1.5 text-xxs uppercase flex items-center mt-2">
            {{ validation.email.message }}
        </span>
        <span class="flex items-center justify-center w-full mt-6 space-x-3">
            <span class="w-[30px] h-[30px] relative block">
                <input @click="validation.privacy.state = null" name="footer-privacy" id="footer-privacy" class="absolute top-0 left-0 w-full h-full outline-none opacity-0 accent-transparent ring-0" type="checkbox" v-model="form.privacy">
                <span class="absolute top-0 left-0 w-full h-full bg-center bg-no-repeat border pointer-events-none fake-checkbox border-white/50"></span>
            </span>
            <label for="footer-privacy" class="cursor-pointer text-[18px] md:text-[19px] xl:text-[20px] font-light">
                <span class="text-white/50">
                    {{$root.translateString('accept')}}
                </span>
                <a class="underline transition-all text-white/50 hover:text-white/100" :href="'/' + lang + '/privacy-policy'">
                    {{$root.translateString('link')}}
                </a>
            </label>
        </span>
        <span v-if="validation.privacy.state != null" class="text-red-400 px-1.5 text-xxs uppercase flex items-center justify-center mt-2">
            {{ validation.privacy.message }}
        </span>
        <span class="flex items-center justify-center w-full mt-6 space-x-3">
            <span class="w-[30px] h-[30px] relative block">
                <input name="marketing" id="marketing" class="absolute top-0 left-0 w-full h-full outline-none opacity-0 accent-transparent ring-0" type="checkbox" v-model="form.marketing">
                <span class="absolute top-0 left-0 w-full h-full bg-center bg-no-repeat border pointer-events-none fake-checkbox border-white/50"></span>
            </span>
            <label for="marketing" class="cursor-pointer">
                <span class="text-[18px] md:text-[19px] xl:text-[20px] font-light text-white/50">
                    {{$root.translateString('marketing')}}
                </span>
            </label>
        </span>
    </form>
</template>

<script>
    export default {

        props: ['lang', 'formToken'],

        data() {
            return {
                csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                error: false,
                sending: false,
                form: {
                    email: '',
                    privacy: false,
                    marketing: false,
                },
                validation: {
                    email: {
                        state: null,
                        message: '',
                    },
                    privacy: {
                        state: null,
                        message: '',
                    },
                },
            }
        },
        methods: {

            checkForm() {

                this.sending = true;
                let error = false;

                Object.keys(this.validation).forEach(key => {
                    this.validation[key].state = null;
                });

                if(this.form.email == '') {
                    this.validation.email.message = this.$root.translateString('form-mandatory');
                    this.validation.email.state = false;
                    error = true;
                }

                if(!(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.form.email))) {
                    this.validation.email.message = this.$root.translateString('form-format');
                    this.validation.email.state = false;
                    error = true;
                }

                if(this.form.country == '') {
                    this.validation.country.message = this.$root.translateString('form-mandatory');
                    this.validation.country.state = false;
                    error = true;
                }

                /*if(this.form.phone && this.form.phone != '' && !(/^[+()\d-]+$/.test(this.form.phone))) {
                    this.validation.phone.message = 'Il campo non è nel formato corretto.';
                    this.validation.phone.state = false;
                    error = true;
                }*/

                if(this.form.privacy === false) {
                    this.validation.privacy.message = this.$root.translateString('form-mandatory');
                    this.validation.privacy.state = false;
                    error = true;
                }

                if(!error) {
                    this.sendMail()
                }else{
                    this.sending = false;
                }

            },

            sendMail() {
                document.querySelector('#newsletterForm').submit();
            }

        }
    }
</script>

<style lang="scss" scoped>

</style>
